import "antd/dist/antd.css"
import axios from "axios"
import { get } from "lodash"
import { Fragment } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import AuthenticatedRoute from "./components/Auth/AuthenticatedRoute"
import Sidebar from "./components/Header/Sidebar"
import Adddish from "./pages/Adddish/Adddish"
import Bookingmanagement from "./pages/Bookingmanagement/Bookingmanagement"
import Communitymanagement from "./pages/Communitymanagement/Communitymanagement"
import Creditmanagement from "./pages/Creditmanagement/Creditmanagement"
import Dashboard from "./pages/Dashboard/Dashboard"
import DiscountFilter from "./pages/Discountfilter/DiscountFilter"
import Eventmanagement from "./pages/Eventmanagement/Eventmanagement"
import Faqs from "./pages/faqs/Faqs"
import Giftcards from "./pages/Giftcards/Giftcards"
import Helpcenter from "./pages/Helpcenter/Helpcenter"
import Login from "./pages/Login/Login"
import Marketing from "./pages/Marketing/Marketing"
import Notifications from "./pages/Notifications/Notifications"
import RestaurantAdmin from "./pages/RestaurantAdmin/RestaurantAdmin"
import Restaurantmanagement from "./pages/Restaurantmanagement/Restaurantmanagement"
import RestaurantSequencemanagement from "./pages/RestaurantSequencemanagement/RestaurantSequencemanagement"
import Settings from "./pages/Settings/Settings"
import SlotManagement from "./pages/SlotManagement/SlotManagement"
import Usermanagement from "./pages/Usermanagement/Usermanagement"
import CuisineManagement from "./pages/cuisine/Cuisines"
import AdvertCampaignPage from "./pages/Advert/Advert"
import Reports from "./pages/Reports/Reports"
import HTCelebrationNotification from "./pages/Notifications-HT-Celebration/HTCelebrationNotificationTable"
import Emailtemplatemanagement from "./pages/Emailtemplatemanagement/Emailtemplatemanagement"

const App = () => {
  axios.interceptors.request.use(
    (config: any) => {
      config.headers.authorization = localStorage.getItem("token")
      return config
    },
    (error: any) => {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    (config: any) => {
      return config
    },
    (error: any) => {
      if (get(error, "response.status") === 403) {
        localStorage.clear()
        window.location.href = "/login"
      }
      return Promise.reject(error)
    }
  )

  return (
    <Router>
      <Fragment>
        <Routes>
          <Route
            path="/login"
            element={
              <>
                <Login />
              </>
            }
          ></Route>
          <Route
            path="/"
            element={
              <>
                <Sidebar />
                <AuthenticatedRoute />
              </>
            }
          >
            <Route path="/" element={<Dashboard />}></Route>
            <Route path="/usermanagement" element={<Usermanagement />}></Route>
            <Route
              path="/restaurantmanagement"
              element={<Restaurantmanagement />}
            ></Route>
            <Route path="/discountfilter" element={<DiscountFilter />}></Route>
            <Route
              path="/restaurantsequence"
              element={<RestaurantSequencemanagement />}
            ></Route>
            <Route path="/advert" element={<AdvertCampaignPage />}></Route>
            <Route
              path="/cuisine-management"
              element={<CuisineManagement />}
            ></Route>

            <Route path="/dishmanagement" element={<Adddish />}></Route>
            <Route path="/email-templates" element={<Emailtemplatemanagement />}></Route>
            <Route path="/slotmanagement" element={<SlotManagement />}></Route>
            <Route
              path="/communitymanagement"
              element={<Communitymanagement />}
            ></Route>
            <Route
              path="/eventmanagement"
              element={<Eventmanagement />}
            ></Route>

            <Route
              path="/bookingmanagement"
              element={<Bookingmanagement />}
            ></Route>

            <Route path="/marketing" element={<Marketing />}></Route>

            <Route path="/giftcards" element={<Giftcards />}></Route>

            <Route path="/helpcenter" element={<Helpcenter />}></Route>

            <Route path="/faq" element={<Faqs />}></Route>

            <Route path="/notifications" element={<Notifications />}></Route>
            <Route
              path="/notifications-ht-celebration"
              element={<HTCelebrationNotification />}
            ></Route>
            <Route path="/reports" element={<Reports />}></Route>

            <Route
              path="/creditmanagement"
              element={<Creditmanagement />}
            ></Route>

            <Route path="/restaurantsadmin" element={<RestaurantAdmin />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </Fragment>
    </Router>
  )
}

export default App
